import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';
import { Button, InputBox, InputView } from '@infoods/lifebase-ui';

import { Nutrient } from '../../../../shared/components/ui-components';
import { NUTRIENTS_ENUM } from '../../../../shared/constants/NUTRIENTS_ENUM';
import { FoodFormNutrient } from '../constants/foodFormNutrients';
import { FoodFormValues } from '../interfaces/FoodFormValues';
import { NutrientInput } from './NutrientInput/NutrientInput';
import { useFoodCalories } from '../hooks/useFoodCalories';
import { Mode } from '../../../../general-types';

const nutrientInputs: {
  nutrient: FoodFormNutrient;
  name: string;
  max: number;
}[] = [
  { nutrient: NUTRIENTS_ENUM.PROTEINS, name: 'Proteins', max: 999 },
  { nutrient: NUTRIENTS_ENUM.CARBS, name: 'Carbs', max: 999 },
  { nutrient: NUTRIENTS_ENUM.FATS, name: 'Fats', max: 999 },
  { nutrient: NUTRIENTS_ENUM.SUGAR, name: 'Sugar', max: 999 },
  { nutrient: NUTRIENTS_ENUM.FIBER, name: 'Fiber', max: 999 },
  { nutrient: NUTRIENTS_ENUM.VEGGIES, name: 'Veggies', max: 999 },
  { nutrient: NUTRIENTS_ENUM.SODIUM, name: 'Sodium', max: 9999 },
];

type NutrientsCardProps = {
  mode: Mode;
  onEdit: () => void;
};

const NutrientsCard = ({ mode, onEdit }: NutrientsCardProps) => {
  const { control } = useFormContext<FoodFormValues>();
  const [amount, unit, name] = useWatch({
    control,
    name: ['recommendedServingSize', 'amountUnit', 'name'],
  });

  const calories = useFoodCalories();

  return (
    <InputBox
      mode={mode}
      title={`Nutrients (required) per ${amount ?? ''} ${unit} of ${name}`}
      adornment={
        mode === 'VIEW' && (
          <Button variant="outlined" size="small" onClick={onEdit}>
            Edit
          </Button>
        )
      }
    >
      {nutrientInputs.map((input) => (
        <NutrientInput key={input.nutrient} mode={mode} {...input} />
      ))}
      {/* UI-only: the field is outside FoodFormValues and never sent */}
      <InputView
        label="Calories (cal)"
        size="medium"
        value={<Nutrient nutrient={NUTRIENTS_ENUM.CALORIES}> {calories} cal </Nutrient>}
      />
    </InputBox>
  );
};

export { NutrientsCard };
